import React from 'react';

import Link from '../../library/link/link';
import Typography from '../../library/typography/typography';
import TireAttributeIcon from './components/tire-attribute-icon/tire-attribute-icon.one-dt';

import {
  TIRE_ATTRIBUTE_ICON_DESCRIPTION,
  TIRE_ATTRIBUTES
} from '../../shared/constants/products';

import './tire-attribute-icons.one-dt.scss';

interface TireAttributeIconsProps {
  className?: string;
  icons?: typeof TIRE_ATTRIBUTES[keyof typeof TIRE_ATTRIBUTES][];
  link?: string;
}

function TireAttributeIcons(props: TireAttributeIconsProps) {
  const { className = '', icons, link } = props;

  if (!(Array.isArray(icons) && icons.length > 0)) {
    return null;
  }

  return (
    <span className={`tire-attribute-icons ${className}`} styleName="container">
      <TireAttributeIcon name={icons[0]} />
      <Typography styleName="icon-description" tag="span">
        {TIRE_ATTRIBUTE_ICON_DESCRIPTION[icons[0]].description ===
        'Three-Peak Mountain Snowflake'
          ? '3PMSF'
          : TIRE_ATTRIBUTE_ICON_DESCRIPTION[icons[0]].description}
      </Typography>
      {icons.length > 1 && link && (
        <>
          <ellipse styleName="ellipse" />
          <Link styleName="icons-link" to={link}>
            + {icons.length - 1}
          </Link>
        </>
      )}
    </span>
  );
}

export default TireAttributeIcons;
